export const coSellOpportunitySections = [
  {
    title: "Information",
    fields: [
      { field: "OwnerId__r.Name" },
      { field: "Name" },
      { field: "Source_ISV_Opportunity__r.Name" },
      { field: "End_Customer__r.Name" },
      { field: "Activity_Type__c" },
      { field: "Leading_Cloud__c" },
      { field: "Description__c" },
      { field: "Use_Case_Details__c" },
      { field: "CloseDate__c" },
    ]
  },
  {
    title: "Opportunity Contacts",
    fields: [
      { field: "AWS_Sales_Rep_Name__c" },
      { field: "WWPS_Dev_Manager_Email__c" },
      { field: "AWS_Sales_Rep_Email__c" },
      { field: "AWS_PSM_Name__c" },
      { field: "AWS_Account_Manager_Name__c" },
      { field: "AWS_PSM_Email__c" },
      { field: "AWS_Account_Manager_Email__c" },
      { field: "AWS_ISM_Name__c" },
      { field: "WWPS_Dev_Manager_Name__c" },
      { field: "AWS_ISM_Email__c" },
      { field: "Partner_Dev_Manager_Name__c" },
      { field: "Partner_Sales_Contact_Name__c" },
      { field: "Partner_Dev_Manager_Email__c" },
      { field: "Partner_Sales_Contact_Email__c" },
    ]
  },
  {
    title: "Activity & Co-Sell Support",
    fields: [
      { field: "Partner_project_title__c" },
      { field: "NextStep__c" },
      { field: "Partner_primary_need_from_AWS__c" },
      { field: "Next_Step_Date__c" },
      { field: "Primary_Needs_From_Aws__c" },
      { field: "Needs_Support_from__c" },
    ]
  },
  {
    title: "End Customer Information",
    fields: [
      { field: "End_Customer_HQ__c" },
      { field: "End_Customer_State__c" },
      { field: "End_Customer_Postal_Code__c" },
      { field: "End_Customer_Website__c" },
      { field: "End_Customer_Industry__c" },
      { field: "Buyer_Title__c" },
      { field: "Buyer_Name__c" },
      { field: "Buyer_Phone__c" },
      { field: "Buyer_Email__c" },
    ]
  },
  {
    title: "Partner Portal Integration",
    fields: [
      { field: "Is_AWS_Referral__c" },
      { field: "ACE_Stage__c" },
      { field: "ACE_External_ID__c" },
    ]
  },
  {
    title: "Marketplace",
    fields: [
      { field: "Is_for_Marketplace__c" },
      { field: "Propensity_to_Buy__c" },
    ]
  },
  {
    title: "Commercials",
    fields: [
      { field: "Amount__c" },
      { field: "MRR__c" },
      { field: "Deal_Term_M__c" },
      { field: "Contract_Effective_Date__c" },
      { field: "Renewal_date__c" },
    ]
  },
  {
    title: "Lost Opportunities",
    fields: [
      { field: "Lost_Reason__c" },
      { field: "Last_Stage_Before_Close__c" },
    ]
  },
  {
    title: "System Information",
    fields: [
      { field: "CreatedBy.Name" },
      { field: "LastModifiedBy.Name" },
    ]
  },
  {
    title: "ACE fields",
    fields: [
      { field: "Business_Title__c" },
      { field: "APN_programs__c" },
      { field: "Marketing_Source__c" },
      { field: "End_Customer_Name__c" },
      { field: "Marketing_Campaign__c" },
      { field: "End_Customer_City__c" },
      { field: "Marketing_Channels__c" },
      { field: "End_Customer_Billing_Address__c" },
      { field: "Marketing_Use_Cases__c" },
      { field: "End_Customer_AWS_Account_ID__c" },
      { field: "Aws_Funding_Used__c" },
      { field: "End_Customer_Duns_Number__c" },
      { field: "Competitive_Tracking__c" },
      { field: "Owner_Email__c" },
      { field: "Other_Competitor_Names__c" },
      { field: "Owner_Phone__c" },
      { field: "Software_Revenue_Delivery_Model__c" },
      { field: "Owner_Last_Name__c" },
      { field: "Customer_Business_Problem__c" },
      { field: "Owner_First_Name__c" },
      { field: "Project_Delivery_Models__c" },
      { field: "AWS_products__c" },
      { field: "Sales_Activities__c" },
      { field: "Customer_Use_Case__c" },
      { field: "Solutions_offered__c" },
    ]
  },
  {
    title: "ACE Sync Collector",
    fields: [
      { field: "ACE_Sync_Collector_Json__c" },
      { field: "ACE_Sync_Collector_Prettier__c" },
    ]
  },
]; 